// extracted by mini-css-extract-plugin
export default {"news_items":"News_news_items__vJta3","news_title":"News_news_title__CmOgE","news_item":"News_news_item__djhmA"};